import {
  Edit,
  Box,
  TextField,
  FormLabel,
  FormHelperText,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";

export const BotExchangeUpdate = () => {
  const {
    saveButtonProps,
    register,
    control,
    formState: { errors },
  } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("bot_exchange_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.bot_exchange_id}
          helperText={(errors as any)?.bot_exchange_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Bot exchange Id"
          name="bot_exchange_id"
        />
        <TextField
          {...register("bot_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.bot_id}
          helperText={(errors as any)?.bot_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Bot Id"
          name="bot_id"
        />
        <TextField
          {...register("exchange", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.exchange}
          helperText={(errors as any)?.exchange?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="string"
          label="Exchange"
          name="exchange"
        />
        <Controller
          control={control}
          name="check_affiliate"
          render={({ field: { onChange, value } }) => (
            <FormControl required error={!!(errors as any)?.check_affiliate}>
              <FormLabel>Check Affiliate</FormLabel>
              <RadioGroup
                row
                onChange={(_, value) => onChange(value === "true")}
                value={value}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="True"
                  value={true}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="False"
                  value={false}
                />
              </RadioGroup>
              <FormHelperText>
                {(errors as any)?.check_affiliate?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
      </Box>
    </Edit>
  );
};
